import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
export function DifferenceSection() {
  const benefits = ['Safely meet your shadow', 'Integrate wounded parts instead of just managing them', 'Build internal safety from the inside out', 'Experience self-love as a living, embodied practice'];
  return <section className="py-24 bg-[#2D1B4E] text-white relative overflow-hidden" data-id="element-52">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-53"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-54">
        <div className="max-w-4xl mx-auto" data-id="element-55">
          <FadeIn data-id="element-56">
            <div className="text-center mb-16" data-id="element-57">
              <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-58">
                This isn’t about fixing yourself. <br data-id="element-59" />
                <span className="text-[#D4A574] italic" data-id="element-60">
                  It’s about reuniting yourself.
                </span>
              </h2>
              <p className="text-xl text-[#E8D5D5] opacity-90" data-id="element-61">
                Inside, you’ll learn how to:
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-62">
            {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.1} className="h-full" data-id="element-63">
                <div className="flex items-start gap-4 bg-white/5 p-6 rounded-xl border border-white/10 hover:bg-white/10 transition-colors h-full" data-id="element-64">
                  <div className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#D4A574] flex items-center justify-center text-[#2D1B4E]" data-id="element-65">
                    <Check className="w-4 h-4 stroke-[3]" data-id="element-66" />
                  </div>
                  <p className="text-lg font-medium text-gray-100" data-id="element-67">{benefit}</p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.5} data-id="element-68">
            <div className="text-center" data-id="element-69">
              <p className="text-2xl font-serif italic text-[#E8D5D5]" data-id="element-70">
                "Insight alone doesn’t create freedom. Integration does."
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}